import { OperatingTime, Week, Schedule } from '~/types/common';

export default function sortOperatingTime(operatingTime: OperatingTime): OperatingTime {
  const compareFn = (a: Schedule, b: Schedule): number => a.start - b.start;

  return {
    [Week.FRI]: operatingTime[Week.FRI].map((v) => v).sort(compareFn),
    [Week.MON]: operatingTime[Week.MON].map((v) => v).sort(compareFn),
    [Week.SAT]: operatingTime[Week.SAT].map((v) => v).sort(compareFn),
    [Week.SUN]: operatingTime[Week.SUN].map((v) => v).sort(compareFn),
    [Week.THU]: operatingTime[Week.THU].map((v) => v).sort(compareFn),
    [Week.TUE]: operatingTime[Week.TUE].map((v) => v).sort(compareFn),
    [Week.WED]: operatingTime[Week.WED].map((v) => v).sort(compareFn),
  };
}
